import { IBilling } from "./billings";
import { Status } from "./state";

export interface IBillingState {
  status: Status;
  requestId: string;
  errorMsg: string | null;
  billing: IBilling;
  originalBilling: IBilling;
  currentStep: BillingStep;
  isUpdating: boolean;
}

export enum BillingStep {
  Costs = "costs",
  Calculation = "calculation",
  Billing = "billing",
}

export const BILLING_STEPS = Object.values(BillingStep);

export type UpdateBillingPaymentScheduleDate = {
  field: keyof Omit<IBilling["paymentSchedule"], "type">;
  value: string;
};

export type UpdateBillingWeightedField = {
  field: keyof IBilling["weighted"];
  value: number;
};
